// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag___XTK3","tagButton":"styles_tagButton__jz_VP","icon":"styles_icon__z5Jil","label":"styles_label__m5MT9"};